import React from "react";
import {
  Page,
  Text,
  View,
  Image
} from "@react-pdf/renderer";

import HeaderImage from "./header.jpeg";
import FooterImage from "./footer.jpeg";
import { pdfStyles } from "./pdfStyles";

export default function PresupuestoPDF({
  presupuesto,
  items,
  condiciones,
  subtotal,
  total,
  descuento
}) {
  return (
    <Page size="A4" style={pdfStyles.page}>

      {/* ========================================= */}
      {/*              HEADER Y FOOTER              */}
      {/* ========================================= */}

      <View fixed style={{ position: "absolute", top: 0, left: 0, width: "100%" }}>
        <Image src={HeaderImage} style={pdfStyles.headerImage} />
      </View>

      <View fixed style={{ position: "absolute", bottom: 0, left: 0, width: "100%" }}>
        <Image src={FooterImage} style={pdfStyles.footerImage} />
      </View>

      {/* ========================================= */}
      {/*                CONTENIDO                  */}
      {/* ========================================= */}

      <Text style={pdfStyles.mainTitle}>COTIZACIÓN DE SERVICIOS</Text>

      <View style={pdfStyles.infoRow}>
        <View style={pdfStyles.infoBox}>
          <Text style={pdfStyles.sectionTitle}>CLIENTE</Text>

          <Text style={pdfStyles.infoText}><Text style={{ fontWeight: "bold" }}>Nombre:</Text> {presupuesto.nombre_cliente}</Text>
          <Text style={pdfStyles.infoText}><Text style={{ fontWeight: "bold" }}>Email:</Text> {presupuesto.correo_cliente || "-"}</Text>
          <Text style={pdfStyles.infoText}><Text style={{ fontWeight: "bold" }}>Dirección:</Text> {presupuesto.direccion_cliente}</Text>
          <Text style={pdfStyles.infoText}><Text style={{ fontWeight: "bold" }}>Ciudad:</Text> {presupuesto.ciudad_cliente}</Text>
          <Text style={pdfStyles.infoText}><Text style={{ fontWeight: "bold" }}>Teléfono:</Text> {presupuesto.telefono_cliente}</Text>
        </View>

        <View style={pdfStyles.infoBox}>
          <Text style={pdfStyles.sectionTitle}>COTIZACIÓN</Text>

          <Text style={pdfStyles.infoText}><Text style={{ fontWeight: "bold" }}>Fecha:</Text> {presupuesto.fecha}</Text>
          <Text style={pdfStyles.infoText}><Text style={{ fontWeight: "bold" }}>Cotización #:</Text> {presupuesto.idpresupuestos}</Text>
          <Text style={pdfStyles.infoText}><Text style={{ fontWeight: "bold" }}>Válido hasta:</Text> {presupuesto.validohasta}</Text>
          <Text style={pdfStyles.infoText}><Text style={{ fontWeight: "bold" }}>Asesor:</Text> {presupuesto.asesor || "-"}</Text>
        </View>
      </View>

      {/* TABLA DE ÍTEMS */}
      <View style={pdfStyles.table}>
        <View style={pdfStyles.tableHeader}>
          <Text style={[pdfStyles.th, { width: "12%" }]}>CÓDIGO</Text>
          <Text style={[pdfStyles.th, { width: "36%" }]}>DESCRIPCIÓN</Text>
          <Text style={[pdfStyles.th, { width: "8%" }]}>CANT.</Text>
          <Text style={[pdfStyles.th, { width: "14%" }]}>PRECIO</Text>
          <Text style={[pdfStyles.th, { width: "14%" }]}>SUBTOTAL</Text>
          <Text style={[pdfStyles.th, { width: "8%" }]}>DESC.</Text>
          <Text style={[pdfStyles.th, { width: "14%" }]}>TOTAL</Text>
        </View>

        {items.map((item, i) => (
          <View key={i} style={pdfStyles.row}>
            <Text style={[pdfStyles.td, { width: "12%" }]}>{item.codigo}</Text>
            <Text style={[pdfStyles.td, { width: "36%", textAlign: "left" }]}>{item.descripcion}</Text>
            <Text style={[pdfStyles.td, { width: "8%" }]}>{item.cantidad}</Text>
            <Text style={[pdfStyles.td, { width: "14%" }]}>{item.precio.toLocaleString()} Gs.</Text>
            <Text style={[pdfStyles.td, { width: "14%" }]}>{item.subtotal.toLocaleString()} Gs.</Text>
            <Text style={[pdfStyles.td, { width: "8%" }]}>{item.descuento}%</Text>
            <Text style={[pdfStyles.td, { width: "14%" }]}>{item.total.toLocaleString()} Gs.</Text>
          </View>
        ))}
      </View>

      {/* TOTALES */}
      <View style={pdfStyles.totalsBox}>
        <View style={pdfStyles.totalRow}>
          <Text>SUBTOTAL:</Text>
          <Text>{subtotal.toLocaleString()} Gs.</Text>
        </View>

        <View style={pdfStyles.totalRow}>
          <Text style={{ color: "red" }}>DESCUENTO:</Text>
          <Text style={{ color: "red" }}>
            {descuento === 0 ? "-" : `${descuento.toLocaleString()} Gs.`}
          </Text>
        </View>

        <View style={[pdfStyles.totalRow, pdfStyles.totalHighlight]}>
          <Text>TOTAL:</Text>
          <Text>{total.toLocaleString()} Gs.</Text>
        </View>
      </View>

      {/* TARIFA PROMEDIO */}
      {Number(presupuesto.averagePrice) > 0 && (
        <Text style={{ marginTop: 8, fontSize: 8 }}>
          Tarifa promedio por hora:{" "}
          <Text style={{ fontWeight: "bold" }}>
            {Number(presupuesto.averagePrice).toLocaleString()} Gs.
          </Text>
        </Text>
      )}

      {/* TÉRMINOS Y CONDICIONES */}
      <Text style={pdfStyles.sectionTitle}>TÉRMINOS Y CONDICIONES</Text>

      <View style={[pdfStyles.condicionesList, { fontSize: 8 }]}>
        {condiciones.map((c, i) => {
          const textoPlano =
            (c.condicion || c.condiciones || "") // ← acepta ambos nombres
              .replace(/<[^>]+>/g, "")
              .trim();

          if (!textoPlano) return null; // si está vacío, no mostrar nada

          return (
            <View key={i} style={pdfStyles.condicionRow}>
              <View style={pdfStyles.miniBullet} />
              <Text>{textoPlano}</Text>
            </View>
          );
        })}
      </View>


      <Text style={pdfStyles.firmaText}>
        Nombre y firma del cliente: ________________________________
      </Text>

      <View wrap={false} style={pdfStyles.finalMessage}>
        <Text>Si tiene preguntas sobre esta cotización, contáctenos.</Text>
        <Text>
          <Text style={{ fontWeight: "bold" }}>Teléfono:</Text> 0986 873181 - 0991 813000 |
          <Text style={{ fontWeight: "bold" }}> Email:</Text> administracion@enfermeriaentuhogar.com.py
        </Text>
        <Text>¡Cuidamos lo que más querés!</Text>
      </View>

    </Page>
  );
}
